import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductShortPage = lazy(() => import('../views/list/ProductShortPage'));

export function ProductShortPageLazy() {
	return (
		<PageSuspense>
			<ProductShortPage />
		</PageSuspense>
	);
}
